// Module
var code = "<mn-medical-care type=\"{{vm.type}}\" ng-model=\"vm.item\" on-save=\"vm.onSave(item)\" on-exit=\"vm.formClosed(saved)\"\n                 on-use=\"vm.useQuotation(newItem)\" class=\"layout-column layout-fill\"></mn-medical-care>";
// Exports
module.exports = code;